import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { clearBlockingError } from '@store/slices/blockingErrorSlice';

export default function BlockingErrorModal() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isOpen, message } = useSelector((state) => state.blockingError);

    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = previousOverflow;
        };
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }

    const handleLeave = () => {
        dispatch(clearBlockingError());
        navigate('/home');
    };

    return (
        <div
            className="blocking-error-overlay"
            role="alertdialog"
            aria-modal="true"
            aria-labelledby="blocking-error-title"
            aria-describedby="blocking-error-message"
        >
            <div className="blocking-error-modal">
                <div className="blocking-error-modal__icon" aria-hidden="true">
                    !
                </div>
                <h4 id="blocking-error-title" className="blocking-error-modal__title">
                    {t('common.accessDenied.title')}
                </h4>
                <p id="blocking-error-message" className="blocking-error-modal__message">
                    {message || t('common.accessDenied.defaultMessage')}
                </p>
                <div className="blocking-error-modal__actions">
                    <button type="button" className="btn btn-primary" onClick={handleLeave}>
                        {t('common.accessDenied.goHome')}
                    </button>
                </div>
            </div>
        </div>
    );
}
